import React, { useEffect } from "react";
//import styles from "./styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import config from "../../../../config";
//import Paper from "../../../../components/paper";
import {
  triggerSegregateDataForRole,
  updateFilterValue,
  triggerFetchAllEndPoints,
  triggerFetchFilterList,
  triggerSetSelectedOptionData,
  triggerSchemeType,
  triggerSchemeName,
  triggerDistRetailerFilter,
  triggerJCAreaFilter,
  resetData,
  triggerAddCategoryToList,
  triggerDashboardAudit,
  setRun,
  // clearPartnerFilter
} from "../../redux/actions";
import {
  getPartnerRoleID,
  validatePartnerRoleType,
  getChildForDistributor,
  getPayoutSchemeRestrictionPartnerRole,
  isRestrictedPayoutSchemeAllRole,
} from "../../utils/common";
import axios from "axios";
import dayjs from "dayjs";

import DashboardFilterView from "../../views/dashboardFilter";

// const JWT = require('jsonwebtoken');
// const fs = require('fs');

class DashboardFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedData: "",
      selectedOptionData: [],
      showCategory:
        this.props.partnerRoleType === "AREA" ||
        this.props.filterValue.partnerName === "JC" ||
        this.props.filterValue.partnerName === "JPM",
    };

    // Create an instance of AbortController
    this.controller = new AbortController();
  }

  fetchOperation = (props) => {
    let option = props.partnerRoleType;
    let data = props.partnerRoleValue;
    if (option !== "NHQ") {
      props.triggerSegregateDataForRole({ data, option });
    } else {
      props.triggerSegregateDataForRole();
    }
  };

  componentDidMount() {
    if (this.props.partnerRoleType === "AREA") {
      this.setState({
        showCategory: true,
      });
    } else if (!this.props.isBusinessType.businessType) {
      let CategoryVar = this?.props?.filterValue?.selectedPartnerRoleName;
      this.setState({
        showCategory:
          CategoryVar &&
          CategoryVar !== "" &&
          CategoryVar !== "ZDMT" &&
          CategoryVar !== "DT" &&
          CategoryVar !== "END" &&
          CategoryVar !== "ITZ",
      });
    } else {
      let CategoryVar =
        this.props.selectedOptionData &&
        this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"] &&
        this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"].split(" - ")[0];
      this.setState({
        showCategory:
          CategoryVar &&
          CategoryVar !== "" &&
          CategoryVar !== "ZDMT" &&
          CategoryVar !== "DT" &&
          CategoryVar !== "END" &&
          CategoryVar !== "ITZ",
      });
    }
    if (this.props.component === "payout") {
      if (
        this.props.partnerRoleType &&
        !validatePartnerRoleType(this.props.partnerRoleType).businessType
      ) {
        let opt =
          this.props.filterValue &&
          this.props.filterValue.selectedPartnerRoleName === "RDS"
            ? "RDS/Chain"
            : "ZD/ZDMT/ARD/MARD";
        let optData = `${this.props.filterValue.selectedPartnerRoleName} -  - ${this.props.filterValue.orgId}`;
        this.fetchSchemes(this.props, optData, opt, opt);
        if (
          this.props.partnerRoleType === "DT" ||
          this.props.partnerRoleType === "END"
        ) {
        } else {
          this.fetchDistRetailer();
        }
      } else if (
        this.props.selectedOptionData &&
        (this.props.selectedOptionData["RDS/Chain"] ||
          this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"] ||
          this.props.selectedOptionData["RDS/ARD/MARD"])
      ) {
        let opt =
          this.props.selectedOptionData &&
          (this.props.selectedOptionData["RDS/Chain"] ||
            this.props.selectedOptionData["RDS/ARD/MARD"])
            ? "RDS/Chain"
            : "ZD/ZDMT/ARD/MARD";
        let optData =
          this.props.selectedOptionData &&
          ((this.props.selectedOptionData["RDS/Chain"] &&
            this.props.selectedOptionData["RDS/Chain"] !== "ALL") ||
            (this.props.selectedOptionData["RDS/ARD/MARD"] &&
              this.props.selectedOptionData["RDS/ARD/MARD"] !== "ALL"))
            ? this.props.selectedOptionData["RDS/Chain"]
              ? this.props.selectedOptionData["RDS/Chain"]
              : this.props.selectedOptionData["RDS/ARD/MARD"]
            : this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"];
        this.fetchSchemes(this.props, optData, opt, opt);
      }
    }
  }

  componentWillUnmount() {
    // Cancel the request when the component unmounts
    this.controller.abort();
  }

  componentDidUpdate(prevProps) {
    const { component, subComponent } = this.props;
    if (component !== "payout") return;
    if (subComponent !== "activation" && subComponent !== "recharge") return;

    const role = getPayoutSchemeRestrictionPartnerRole(
      this.props.filterValue,
      this.props.selectedOptionData,
      this.props.isBusinessType,
      this.props.partnerRoleType
    );
    if (!isRestrictedPayoutSchemeAllRole(role)) return;

    const schemeList = this.props.filteredArray?.Scheme;
    const prevSchemeList = prevProps.filteredArray?.Scheme;
    if (!Array.isArray(schemeList) || schemeList.length === 0) return;
    if (this.props.selectedOptionData?.Scheme !== "ALL") return;
    if (schemeList === prevSchemeList) return;

    const first = schemeList.find((s) => s !== "ALL");
    if (!first) return;

    this.props.triggerSetSelectedOptionData(
      {
        ...this.props.selectedOptionData,
        Scheme: first,
      },
      this.state.showCategory
    );
  }

  getSchemeOptionDisabled = (option) => {
    if (this.props.component !== "payout") return false;
    if (
      this.props.subComponent !== "activation" &&
      this.props.subComponent !== "recharge"
    )
      return false;
    const role = getPayoutSchemeRestrictionPartnerRole(
      this.props.filterValue,
      this.props.selectedOptionData,
      this.props.isBusinessType,
      this.props.partnerRoleType
    );
    if (!isRestrictedPayoutSchemeAllRole(role)) return false;
    return option === "ALL";
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.component === "payout") {
      if (
        this.props.selectedOptionData &&
        (this.props.selectedOptionData["RDS/Chain"] ||
          this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"] ||
          this.props.selectedOptionData["RDS/ARD/MARD"])
      ) {
        if (
          this.props.headerSelectedDateFrom !==
            nextProps.headerSelectedDateFrom ||
          this.props.headerSelectedDateTo !== nextProps.headerSelectedDateTo
        ) {
          let opt =
            this.props.selectedOptionData &&
            (this.props.selectedOptionData["RDS/Chain"] ||
              this.props.selectedOptionData["RDS/ARD/MARD"])
              ? "RDS/Chain"
              : "ZD/ZDMT/ARD/MARD";
          let optData =
            this.props.selectedOptionData &&
            ((this.props.selectedOptionData["RDS/Chain"] &&
              this.props.selectedOptionData["RDS/Chain"] !== "ALL") ||
              (this.props.selectedOptionData["RDS/ARD/MARD"] &&
                this.props.selectedOptionData["RDS/ARD/MARD"] !== "ALL"))
              ? this.props.selectedOptionData["RDS/Chain"]
                ? this.props.selectedOptionData["RDS/Chain"]
                : this.props.selectedOptionData["RDS/ARD/MARD"]
              : this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"];
          this.fetchSchemes(nextProps, optData, opt, opt);
        }
      }
      if (
        this.props.partnerRoleType &&
        !validatePartnerRoleType(this.props.partnerRoleType).businessType
      ) {
        if (
          this.props.headerSelectedDateFrom !==
            nextProps.headerSelectedDateFrom ||
          this.props.headerSelectedDateTo !== nextProps.headerSelectedDateTo
        ) {
          let opt =
            this.props.filterValue &&
            this.props.filterValue.selectedPartnerRoleName === "RDS"
              ? "RDS/Chain"
              : "ZD/ZDMT/ARD/MARD";
          let optData = `${this.props.filterValue.selectedPartnerRoleName} -  - ${this.props.filterValue.orgId}`;
          this.fetchSchemes(nextProps, optData, opt, opt);
          if (
            this.props.partnerRoleType === "DT" ||
            this.props.partnerRoleType === "END"
          ) {
          } else {
            this.fetchDistRetailer();
          }
        }
      }
    }
    if (this.props.isBusinessType.businessType) {
      if (nextProps.partnerRoleType === "AREA") {
        this.setState({
          showCategory: true,
        });
      } else if (
        this.props.selectedOptionData &&
        this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"] !==
          nextProps.selectedOptionData["ZD/ZDMT/ARD/MARD"]
      ) {
        let CategoryVar =
          nextProps.selectedOptionData &&
          nextProps.selectedOptionData["ZD/ZDMT/ARD/MARD"] &&
          nextProps.selectedOptionData["ZD/ZDMT/ARD/MARD"].split(" - ")[0];
        this.setState({
          showCategory:
            CategoryVar &&
            CategoryVar !== "" &&
            CategoryVar !== "ZDMT" &&
            CategoryVar !== "DT" &&
            CategoryVar !== "END" &&
            CategoryVar !== "ITZ" &&
            CategoryVar !== "RZD",
        });
      }
      if (nextProps.filterValue.partnerName === "JPM") {
        this.setState({
          showCategory: true,
        });
        // this.fetchDistRetailer();
      }
    }

    // if (this.props.partnerRoleType === "AREA" || this.props.partnerRoleType === "JC" || this.props.partnerRoleType === "JP") {
    //     if ((this.props.headerSelectedDateFrom !== nextProps.headerSelectedDateFrom) || (this.props.headerSelectedDateTo !== nextProps.headerSelectedDateTo)) {
    //         let obj = {
    //             areaJcFlag: nextProps.partnerRoleType == "AREA" ? "AREA" : "JC",
    //             id: nextProps.filterValue.selectedArea,
    //             jpFlag: nextProps.partnerRoleType,
    //             option: nextProps.partnerRoleType,
    //         }
    //         this.fetchJCJP(obj);
    //     }
    // }
  }

  fetchDistRetailer(id, type) {
    let rdId;
    let extraData;
    if (
      this.props.partnerRoleType === "ZD" ||
      this.props.partnerRoleType === "ZDMT" ||
      this.props.partnerRoleType === "ITZ"
    ) {
      rdId = this.props.filterValue.orgId;
      extraData = "Distributor";
      if (type === "Retailer") {
        rdId = id;
        extraData = type;
      }
    } else {
      rdId = this.props.filterValue.orgId;
      extraData = "Retailer";
    }

    let obj = {
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        id: rdId ? rdId?.trim() : "ALL",
        isRedisActive: "YES",
      },
    };

    this.props.triggerDistRetailerFilter(obj, extraData);
  }

  fetchSchemes = (props, data, option, scheme, schemeType) => {
    const { signal } = this.controller;
    let getUrl = {
      device: {
        urlSchemeType: "/device-payout-scheme-type-filter",
        urlSchemeName: "/device-payout-scheme-name-filter",
        moduleName: "device",
      },
      activation: {
        urlSchemeType: "/activation-scheme-type",
        urlSchemeName: "/activation-scheme-name",
        moduleName: "Activation_Payout",
      },
      recharge: {
        urlSchemeType: "/recharge-scheme-type",
        urlSchemeName: "/recharge-scheme-name",
        moduleName: "Recharge_Payout",
      },
    };

    let obj1 = {
      headers: {
        "Content-Type": "application/json",
        urlSchemeType: props.subComponent
          ? getUrl[props.subComponent].urlSchemeType
          : "",
        urlSchemeName: props.subComponent
          ? getUrl[props.subComponent].urlSchemeName
          : "",
      },
      params: {
        dispValue: 10000,
        fromDate: props.headerSelectedDateFrom, // headerSelectedDateFrom,,
        id: data && data.split(" - ")[2],
        isRedisActive: "YES",
        jprTypeName: "",
        moduleName: getUrl[props.subComponent].moduleName, //"recharge",
        partnerRoleType: data && data.split(" - ")[0],
        section: "payout",
        toDate: props.headerSelectedDateTo, //"30-Jun-2020",
        schemeType: schemeType ? schemeType : "",
      },
    };

    if (scheme === "Scheme_Type") {
      props.triggerSchemeName(obj1, signal);
    } else {
      // Only require a valid (non-inverted) range here. Do not require same calendar month:
      // after Home/back, RESET_FILTERS_TO_DEFAULT sets from = today−6 and to = today, which can
      // span months; CustomHeader then clamps payout dates, but this runs earlier in mount and
      // would otherwise skip filterSchemeType entirely on the second visit.
      !dayjs(props.headerSelectedDateFrom).isAfter(
        dayjs(props.headerSelectedDateTo)
      ) &&
        props.triggerSchemeType(
          { ...obj1 },
          (data, params) => {
            if (data?.content?.length !== 0) {
              props.triggerSchemeName(
                {
                  ...obj1,
                  params: {
                    ...obj1.params,
                    schemeType: data?.content?.[0]?.schemeTypeName ?? "",
                  },
                },
                signal
              );
            }
          },
          signal
        );
    }
  };

  fetchJCJP = (obj) => {
    let obj1 = {
      headers: {
        "Content-Type": "application/json",
        SAN: this.props.filterValue.SAN,
      },
      params: {
        areaJcFlag: obj.type,
        id: obj.data,
        jpFlag: obj.jpFlag,
      },
    };
    // this.fetchJCJP()
    this.props.triggerJCAreaFilter(obj1, obj.option);
  };

  changeHandler = (data, option, updatedHomeReducer) => {
    if (
      this.props.component === "payout" &&
      (this.props.subComponent === "activation" ||
        this.props.subComponent === "recharge") &&
      option === "Scheme" &&
      data === "ALL"
    ) {
      const role = getPayoutSchemeRestrictionPartnerRole(
        this.props.filterValue,
        updatedHomeReducer?.selectedOptionData ?? this.props.selectedOptionData,
        this.props.isBusinessType,
        this.props.partnerRoleType
      );
      if (isRestrictedPayoutSchemeAllRole(role)) {
        return;
      }
    }

    // Define the hierarchy order explicitly
    const optionHierarchy = [
      "Region",
      "State",
      "ZD/ZDMT/ARD/MARD",
      "RDS/Chain",
      "Retail Category",
      "Scheme_Type",
      "Scheme",
    ];

    let showCategory = this.state.showCategory;

    if (
      option !== "Retail Category" &&
      option !== "Distributors" &&
      option !== "Retailers"
    ) {
      if (option === "State") {
        delete this.props.filteredArray["ZD/ZDMT/ARD/MARD"];
      }

      // Find the index of the current option in the hierarchy
      const optionIndex = optionHierarchy.indexOf(option);

      if (
        this.props.component === "payout" &&
        (option === "RDS/Chain" || option === "RDS/ARD/MARD")
      ) {
        //For Payout
        if (data !== "ALL") {
          delete this.props.selectedOptionData["Scheme_Type"];
          delete this.props.selectedOptionData["Scheme"];
        }
      } else {
        // Delete all options that come after the current option in the hierarchy
        for (let i = optionIndex + 1; i < optionHierarchy.length; i++) {
          const nextOption = optionHierarchy[i];
          if (nextOption !== "Retail Category") {
            delete this.props.selectedOptionData[nextOption];
          }
        }
      }
    }

    // if (this.props.isBusinessType.businessType) {
    //     if (option === "ZD/ZDMT/ARD/MARD") {
    //         showCategory = CategoryVar && CategoryVar !== "" && CategoryVar !== 'ZDMT' && CategoryVar !== 'DT' && CategoryVar !== 'END' && CategoryVar !== 'ITZ' && CategoryVar !== 'RZD';
    //     }
    // }
    if (option === "Scheme_Type") {
      const actualData = this.props.filterSchemeType.data.content.filter(
        (val, index) => {
          return data === val.schemeType; // this is the scheme type that goes in scheme-name api call
        }
      );

      this.props.triggerSetSelectedOptionData(
        {
          ...updatedHomeReducer.selectedOptionData,
          [option]: actualData[0],
        },
        showCategory
      );
    } else {
      this.props.triggerSetSelectedOptionData(
        {
          ...updatedHomeReducer.selectedOptionData,
          [option]: data,
        },
        showCategory
      );
    }

    this.setState({
      showCategory,
    });

    let obj = {
      "Content-Type": "application/json",
      state: data,
    };

    if (option === "State") {
      // this.props.clearPartnerFilter();
      this.props.triggerFetchFilterList(obj, () => {
        this.props.triggerSegregateDataForRole(
          { data, option },
          (updatedState) => {
            this.changeHandler(
              updatedState.homeReducer.filteredArray?.["ZD/ZDMT/ARD/MARD"]?.[0],
              "ZD/ZDMT/ARD/MARD",
              updatedState.homeReducer
            );
          }
        );
      });
    } else if (
      this.props.component === "payout" &&
      (option === "ZD/ZDMT/ARD/MARD" || option === "RDS/Chain")
    ) {
      if (option === "RDS/Chain" && data === "ALL") {
      } else {
        this.props.triggerSegregateDataForRole(
          { data, option },
          (updatedState) => {
            if (option === "ZD/ZDMT/ARD/MARD") {
              this.changeHandler(
                updatedState.homeReducer.filteredArray?.["RDS/Chain"]?.[0],
                "RDS/Chain",
                updatedState.homeReducer
              );
            }
          }
        );
        this.fetchSchemes(this.props, data, option, option, "");
      }
    } else if (this.props.component === "payout" && option === "Scheme_Type") {
      let opt =
        this.props.selectedOptionData &&
        this.props.selectedOptionData["RDS/Chain"] &&
        this.props.selectedOptionData["RDS/Chain"] !== "ALL"
          ? "RDS/Chain"
          : "ZD/ZDMT/ARD/MARD";
      let optData =
        this.props.selectedOptionData &&
        this.props.selectedOptionData["RDS/Chain"] &&
        this.props.selectedOptionData["RDS/Chain"] !== "ALL"
          ? this.props.selectedOptionData["RDS/Chain"]
          : this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"];
      if (
        this.props.selectedOptionData &&
        this.props.selectedOptionData["RDS/ARD/MARD"] &&
        this.props.selectedOptionData["RDS/ARD/MARD"] !== "ALL"
      ) {
        optData = this.props.selectedOptionData["RDS/ARD/MARD"];
      }
      if (
        this.props.partnerRoleType &&
        !validatePartnerRoleType(this.props.partnerRoleType).businessType
      ) {
        opt =
          this.props.filterValue &&
          this.props.filterValue.selectedPartnerRoleName === "RDS"
            ? "RDS/Chain"
            : "ZD/ZDMT/ARD/MARD";
        optData =
          this.props.filterValue &&
          `${this.props.filterValue.selectedPartnerRoleName} -  - ${this.props.filterValue.orgId}`;
        if (
          this.props.selectedOptionData &&
          this.props.selectedOptionData.Distributors &&
          this.props.selectedOptionData.Distributors !== "ALL"
        ) {
          optData =
            this.props.filterValue &&
            `${
              this.props.filterValue &&
              getChildForDistributor(
                this.props.filterValue.selectedPartnerRoleName
              )
            } -  - ${
              this.props.selectedOptionData.Distributors.split(" - ")[
                this.props.selectedOptionData.Distributors.split(" - ").length -
                  1
              ]
            }`;
        }
      }

      let FST = data;
      if (data) {
        FST = this.props.filterSchemeType.data.content.filter((val, index) => {
          return data === val.schemeType; // this is the scheme type that goes in scheme-name api call
        });
      }
      this.fetchSchemes(
        this.props,
        optData,
        opt,
        option,
        FST && FST[0] && FST[0].schemeTypeName
      );
    } else if (this.props.component === "payout" && option === "Distributors") {
      const distId =
        data && data.includes(" - ")
          ? data.split(" - ")[data.split(" - ").length - 1]
          : data && data.split("-")[1];
      this.fetchDistRetailer(distId, "Retailer");
      if (
        this.props.partnerRoleType &&
        !validatePartnerRoleType(this.props.partnerRoleType).businessType
      ) {
        let opt =
          this.props.filterValue &&
          this.props.filterValue.selectedPartnerRoleName === "RDS"
            ? "RDS/Chain"
            : "ZD/ZDMT/ARD/MARD";
        let optData =
          this.props.filterValue &&
          `${getChildForDistributor(
            this.props.filterValue.selectedPartnerRoleName
          )} -  - ${data && data.split(" - ")[data.split(" - ").length - 1]}`;
        // Run scheme-type API first, then scheme-name (same as ZD/RDS chain).
        // Passing scheme === "Scheme_Type" skips scheme-type and only calls scheme-name (empty list).
        this.fetchSchemes(this.props, optData, opt, opt, "");
      }
    } else {
      if (
        validatePartnerRoleType(this.props.partnerRoleType).businessType &&
        !(option === "Scheme")
      ) {
        if (option === "JC") {
          let obj = {
            type: option,
            data: data,
            jpFlag: "null",
            option,
          };
          this.fetchJCJP(obj);
          // this.fetchDistRetailer();
        } else {
          if (
            this.props.partnerRoleType === "AREA" ||
            this.props.partnerRoleType === "JC" ||
            this.props.partnerRoleType === "JP"
          ) {
            if (option === "RDS/ARD/MARD") {
              if (this.props.component === "payout") {
                // this.props.triggerSegregateDataForRole({ data, option });
                this.fetchSchemes(this.props, data, option);
              }

              if (this.props.partnerRoleType !== "AREA") {
                let obj = {
                  type: "JP",
                  data: data.split("-")[2].trim(),
                  jpFlag: "JCJP",
                  option,
                };
                this.fetchJCJP(obj);
              }
            }
          } else {
            if (option !== "Retail Category") {
              this.props.triggerSegregateDataForRole(
                { data, option },
                (updatedState) => {
                  if (option === "ZD/ZDMT/ARD/MARD") {
                    this.changeHandler(
                      updatedState.homeReducer.filteredArray?.[
                        "RDS/Chain"
                      ]?.[0],
                      "RDS/Chain",
                      updatedState.homeReducer
                    );
                  } else if (option === "Region") {
                    this.changeHandler(
                      updatedState.homeReducer.filteredArray?.["State"]?.[0],
                      "State",
                      updatedState.homeReducer
                    );
                  }
                }
              );
            }
          }
        }
      }
    }
  };

  sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "run",
        dashboard: this.props.dashboard,
        empId: this.props.filterValue?.orgId?.length
          ? this.props.filterValue?.orgId
          : this.props.filterValue?.agentId,
        empRole: this.props.filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: this.props.filterValue?.site,
        viewName: "",
      },
    };
    triggerDashboardAudit(obj);
  };

  runButtonClickHandler = (e) => {
    this.sendAudit();
    this.props.setRun();

    // const privateKey = fs.readFileSync('private.key');
    // const token = JWT.sign({ foo: 'bar' }, privateKey, { algorithm: 'RS256' });
    // console.log(this.props.isBusinessType.businessType)
    // if (this.props.isBusinessType.businessType) {
    //     this.props.resetData();
    // }
    let obj = {
      ...this.props.filterValue,
      selectedRegion:
        this.props.selectedOptionData && this.props.selectedOptionData.Region
          ? this.props.selectedOptionData.Region
          : "", //'North',
      selectedState:
        this.props.selectedOptionData && this.props.selectedOptionData.State
          ? this.props.selectedOptionData.State
          : "", //'Delhi',
      selectedRole:
        this.props.selectedOptionData &&
        this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"]
          ? this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"]
          : "", //'ZD - Shivalik Distribution Pvt Ltd - 0660002840',
      selectedRchain:
        this.props.selectedOptionData &&
        this.props.selectedOptionData["RDS/Chain"] &&
        this.props.selectedOptionData["RDS/Chain"] !== "ALL"
          ? this.props.selectedOptionData["RDS/Chain"]
          : "",
      selectedCategory:
        this.props.selectedOptionData &&
        this.props.selectedOptionData["Retail Category"]
          ? this.props.selectedOptionData["Retail Category"]
          : "",
      selectedPartnerRoleType:
        this.props.selectedOptionData &&
        this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"]
          ? getPartnerRoleID(
              this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"]
                .split("-", 1)[0]
                .trim()
            )
          : this.props.filterValue.selectedPartnerRoleType, //'754'
      selectedPartnerRoleName:
        this.props.selectedOptionData &&
        this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"]
          ? this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"]
              .split("-", 1)[0]
              .trim()
          : this.props.filterValue.selectedPartnerRoleName,

      selectedSchemeType:
        this.props.selectedOptionData &&
        this.props.selectedOptionData["Scheme_Type"]
          ? this.props.selectedOptionData["Scheme_Type"]
          : "",
      selectedSchemeName:
        this.props.selectedOptionData && this.props.selectedOptionData["Scheme"]
          ? this.props.selectedOptionData["Scheme"]
          : "",

      selectedDistributor:
        this.props.selectedOptionData &&
        this.props.selectedOptionData["Distributors"]
          ? this.props.selectedOptionData["Distributors"]
          : "",
      selectedRetailer:
        this.props.selectedOptionData &&
        this.props.selectedOptionData["Retailers"]
          ? this.props.selectedOptionData["Retailers"]
          : "",
      selectedRetailerFilter: "",
      selectedJC:
        this.props.selectedOptionData &&
        this.props.selectedOptionData["All/JC/JP"]
          ? this.props.selectedOptionData["All/JC/JP"]
          : "",
      selectedJP:
        this.props.selectedOptionData && this.props.selectedOptionData["All/JP"]
          ? this.props.selectedOptionData["All/JP"]
          : "",
    };

    let pRole =
      this.props.selectedOptionData &&
      this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"]
        ? getPartnerRoleID(
            this.props.selectedOptionData["ZD/ZDMT/ARD/MARD"]
              .split("-", 1)[0]
              .trim()
          )
        : this.props?.filterValue?.selectedPartnerRoleName;
    if (
      this.props.selectedOptionData &&
      this.props.selectedOptionData["RDS/Chain"] &&
      this.props.selectedOptionData["RDS/Chain"] !== "ALL"
    ) {
      pRole = getPartnerRoleID(
        this.props.selectedOptionData["RDS/Chain"].split("-", 1)[0].trim()
      )
        ? getPartnerRoleID(
            this.props.selectedOptionData["RDS/Chain"].split("-", 1)[0].trim()
          )
        : "755";
      obj.selectedRole = `${this.props.selectedOptionData["RDS/Chain"]}`;
      obj.selectedPartnerRoleType = pRole;
      obj.selectedPartnerRoleName = this.props.selectedOptionData["RDS/Chain"]
        .split("-", 1)[0]
        .trim();
    }
    if (
      this.props.selectedOptionData &&
      this.props.selectedOptionData["RDS/ARD/MARD"]
    ) {
      pRole = getPartnerRoleID(
        this.props.selectedOptionData["RDS/ARD/MARD"].split("-", 1)[0].trim()
      );
      obj.selectedRole = `${this.props.selectedOptionData["RDS/ARD/MARD"]}`;
      obj.selectedPartnerRoleType = pRole;
      obj.selectedPartnerRoleName = this.props.selectedOptionData[
        "RDS/ARD/MARD"
      ]
        .split("-", 1)[0]
        .trim();

      if (
        this.props.selectedOptionData["All/JC/JP"] &&
        this.props.selectedOptionData["All/JC/JP"] !== "ALL"
      ) {
        pRole = `JC ${this.props.selectedOptionData["RDS/ARD/MARD"]
          .split("-", 1)[0]
          .trim()}`;
      }
    }

    if (this.props.filterValue.partnerName === "JPM") {
      obj.selectedRole = `${this.props.selectedOptionData["All/JP"]}`;
      pRole = "JP";
    }

    if (this.props.isBusinessType.businessType) {
      if (!obj.selectedRole) {
        alert("Please select partner role to continue");
      } else {
        this.props.updateFilterValue(obj);
        this.props.resetData();
        this.props.triggerFetchAllEndPoints({
          role: pRole,
          roleType: this.props.filterValue.partnerName.toUpperCase(),
          partnerRoleType: this?.props?.filterValue?.partnerName,
          forTiles: "NO",
          site: this?.props?.filterValue?.site,
        });
      }
    } else {
      this.props.updateFilterValue(obj);
    }
  };

  render() {
    return (
      <DashboardFilterView
        partnerRoleType={this.props.partnerRoleType}
        selectedOptionData={this.props.selectedOptionData}
        component={this.props.component}
        isChild={this.props.isChild}
        subComponent={this.props.subComponent}
        showCategory={this.state.showCategory}
        filteredArray={this.props.filteredArray}
        showDropdown={this.state.showDropdown}
        changeHandler={this.changeHandler}
        runButtonClickHandler={this.runButtonClickHandler}
        getSchemeOptionDisabled={this.getSchemeOptionDisabled}
      />
    );
  }
}

const mapStateToProps = (state) => {
  let {
    filterList,
    segregatedData,
    filteredArray,
    partnerRoleValue,
    selectedOptionData,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    showSchemeType,
    showSchemeName,
    showDistributors,
    showRetailers,
    filterValue,
    partnerRoleType,
    isBusinessType,
    isChild,
    filterSchemeType,
  } = state.homeReducer;

  return {
    filterList,
    segregatedData,
    filteredArray,
    partnerRoleValue,
    selectedOptionData,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    showSchemeType,
    showSchemeName,
    showDistributors,
    showRetailers,
    filterValue,
    partnerRoleType,
    isBusinessType,
    isChild,
    filterSchemeType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      triggerSegregateDataForRole,
      updateFilterValue,
      triggerFetchAllEndPoints,
      triggerFetchFilterList,
      triggerSetSelectedOptionData,
      triggerSchemeType,
      triggerSchemeName,
      triggerDistRetailerFilter,
      triggerJCAreaFilter,
      resetData,
      triggerAddCategoryToList,
      setRun,
      // clearPartnerFilter,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(DashboardFilter);
